import { StopsTableColumn } from './tableColumns';

export enum StopActionType {
  SET_STOPS_TABLE_COLUMNS = `SET_STOPS_TABLE_COLUMNS`,
}

export interface SetStopsTableColumnsAction {
  type: StopActionType.SET_STOPS_TABLE_COLUMNS;
  payload: Array<StopsTableColumn>;
}

export type StopActions = SetStopsTableColumnsAction;
